import Cookies from 'js-cookie';
import authService from 'services/auth.service';
import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const refreshToken = authService.getRefreshToken();

      if (refreshToken) {
        const user = Cookies.get('user');
        setUser(safeJsonParse(user));
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      authService.logout();
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    authService.logout();
  };

  const value = {
    user,
    isAuthenticated: !!user,
    loading,
    logout,
    setUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

const safeJsonParse = (str) => {
  try {
    return JSON.parse(decodeURIComponent(str));
  } catch (error) {
    return null;
  }
};
